// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"593520ba","703":"5a361b19","787":"05dc9179"}[chunkId] + ".chunk.js";
};